// Backdrop de carregamento — mockup "Loading Backdrop": véu escurecido com
// blur e o spinner Aeros (dois anéis pulsando, um arco girando e o monograma
// em gradiente). Aceita `title`/`subtitle` para ações demoradas; sem elas,
// mostra só o spinner.
import React, { useState } from "react";

import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import { AEROS } from "../../styles/aerosTokens";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.text.primary,
    backgroundColor:
      theme.palette.type === "light"
        ? "rgba(246,247,251,0.72)"
        : "rgba(7,8,13,0.72)",
    backdropFilter: "blur(6px)",
    display: "flex",
    flexDirection: "column",
    gap: 22,
  },
  spinner: { position: "relative", width: 72, height: 72 },
  ring: {
    position: "absolute",
    inset: 0,
    borderRadius: "50%",
    animation: "$pulseRing 1.6s ease-out infinite",
  },
  ringPurple: { border: `2px solid ${theme.palette.primary.main}80` },
  ringCyan: {
    border: `2px solid ${AEROS.cyan}80`,
    animationDelay: "0.5s",
  },
  arc: {
    position: "absolute",
    inset: 6,
    borderRadius: "50%",
    border: "3px solid rgba(255,255,255,0.08)",
    borderTopColor: AEROS.cyan,
    borderRightColor: theme.palette.primary.main,
    animation: "$spin 0.9s linear infinite",
  },
  mark: {
    position: "absolute",
    inset: 22,
    borderRadius: 9,
    background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${AEROS.cyan})`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#07080D",
    fontWeight: 800,
    fontSize: 15,
    fontFamily: AEROS.fontDisplay,
    overflow: "hidden",
    "& img": { width: "100%", height: "100%", objectFit: "contain" },
  },
  text: { textAlign: "center" },
  title: { fontSize: 14, fontWeight: 600 },
  subtitle: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    marginTop: 4,
  },
  "@keyframes pulseRing": {
    "0%": { transform: "scale(0.6)", opacity: 0.9 },
    "100%": { transform: "scale(1.6)", opacity: 0 },
  },
  "@keyframes spin": {
    to: { transform: "rotate(360deg)" },
  },
}));

export const AerosSpinner = () => {
  const classes = useStyles();
  const theme = useTheme();
  // Favicon da whitelabel (ou o padrão) no quadrado central; "P" só se a
  // imagem faltar ou falhar.
  const [broken, setBroken] = useState(false);
  const favicon = !broken && theme.appLogoFavicon ? theme.appLogoFavicon : "";
  return (
    <div className={classes.spinner} role="progressbar">
      <div className={`${classes.ring} ${classes.ringPurple}`} />
      <div className={`${classes.ring} ${classes.ringCyan}`} />
      <div className={classes.arc} />
      <div className={classes.mark}>
        {favicon ? <img src={favicon} alt="" onError={() => setBroken(true)} /> : "P"}
      </div>
    </div>
  );
};

const BackdropLoading = ({ title, subtitle }) => {
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={true}>
      <AerosSpinner />
      {(title || subtitle) && (
        <div className={classes.text}>
          {title && <div className={classes.title}>{title}</div>}
          {subtitle && <div className={classes.subtitle}>{subtitle}</div>}
        </div>
      )}
    </Backdrop>
  );
};

export default BackdropLoading;
